// Tiny safe wrapper around the Meta Pixel
export const fbTrack = (event, params) => {
  if (typeof window === "undefined") return;
  if (typeof window.fbq !== "function") return;
  try {
    if (params) {
      window.fbq("track", event, params);
    } else {
      window.fbq("track", event);
    }
  } catch (_) {
    // swallow — never break the UI for analytics
  }
};
